import { render, staticRenderFns } from "./standard-tread-value.vue?vue&type=template&id=585b2080&scoped=true&"
import script from "./standard-tread-value.vue?vue&type=script&lang=ts&"
export * from "./standard-tread-value.vue?vue&type=script&lang=ts&"
import style0 from "./standard-tread-value.vue?vue&type=style&index=0&id=585b2080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b2080",
  null
  
)

export default component.exports